import React from 'react'
import HeroFilter from "./HeroFilter";


const Hero = () => {
  return (
    <section id='inicio' className="home1-overlay home1_bgi1">
      <div className=""  style={{height:"100%",width:"100%"}}>
        <div className="row posr" style={{height:"100%",margin:"0"}}>
          <div className="col-lg-12" style={{padding:"0"}}>
            <HeroFilter />
          </div>
        </div>
      </div>
      {/* End .container */}
    </section>

  )
}

export default Hero;
